import { inject, Injectable } from '@angular/core';
import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';
import { ContextMenuOptionsService } from './context-menu-options.service';
import { ContextMenuService } from './context-menu.service';

@Injectable()
export class TimelineContextMenuService {
  private contextMenuOptionsService = inject(ContextMenuOptionsService);
  private contextMenuService = inject(ContextMenuService);

  open(clientPoint: Point2D) {
    const menuOptions =
      this.contextMenuOptionsService.getTimelineContextMenuOptions();
    this.contextMenuService.open(menuOptions, clientPoint);
  }
}
